<template>
<div class="bto-sb-mybets">
  <div class="bto-sb-mybets-menu" ref="mybetsMenu">
    <ul>
      <li :class="{'bto-sb-mybets-menu-active': tab.code === activeTab.code}" v-for="(tab,i) in TABS" :key="i">
        <a @click="changeTab(tab)">{{t(tab.name)}}</a>
      </li>
    </ul>
  </div>
  <div class="bto-sb-mybets-filter" ref="mybetsFilter">
    <div class="bto-sb-mybets-filter-group">
      <ul>
        <li>
          <label>{{t('BetSlip.No.')}}</label>
          <input type="number" class="bto-sb-form-input" v-model="betSlipSearch" @keypress.enter="findMybets">
        </li>
        <li>
          <label>{{t('Mobile.Type')}}</label>
          <div class="bto-sb-form-select">
            <select v-model="activeMatchType">
              <option v-for="(mt,i) in MATCH_TYPES" :key="i" :value="mt.val">{{t(mt.text)}}</option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
          </div>
        </li>
        <li>
          <label>{{t('BetSlip.From')}}</label>
          <span class="bto-sb-datepicker">
            <date-picker
              v-model="fromDate"
              :format="DATE_FORMAT"
              :lang="PLAYER_LANG"
              :clearable="true"
              :not-after="toDate">
                <i class="bto-app-date"></i>
              </date-picker>
          </span>
        </li>
        <li class="bto-sb-datepicker-space">
          <label>{{t('BetSlip.To')}}</label>
          <span class="bto-sb-datepicker">
            <date-picker
              v-model="toDate"
              :format="DATE_FORMAT"
              :lang="PLAYER_LANG"
              :clearable="true"
              :not-before="fromDate"
              :not-after="Date.now()">
                <i class="bto-app-date"></i>
              </date-picker>
          </span>
        </li>
        <!-- <li>
          <label>Agent</label>
          <div class="bto-sb-form-select">
            <select>
              <option>All</option>
              <option>Agent 1</option>
              <option>Agent 2</option>
              <option>Agent 3</option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
          </div>
        </li>
        <li>
          <label>Choose Client</label>
          <div class="bto-sb-form-select">
            <select>
              <option>All</option>
              <option>Client 1</option>
              <option>Client 2</option>
              <option>Client 3</option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
          </div>
        </li> -->
      </ul>
    </div>
    <div class="bto-sb-mybets-filter-group">
      <button type="submit" class="bto-sb-form-btn" @click="findMybets">{{t('BetSlip.Find')}}</button>
    </div>
  </div>
  <div class="bto-sb-mybets-content" :class="{
    'bto-sb-mybets-content-loader': isLoading,
    'bto-sb-scrollbar': IS_AGENT
    }"
    :id="IS_AGENT ? 'mybets-scrollbar': null">
    <div class="bto-sb-spinner-v1" v-if="isLoading"></div>
    <div class="bto-sb-mybets-results">
      <div id="bto-sb-accordion" v-if="myBets.length">
        <div class="bto-sb-accordion-card" 
            :class="{'bto-sb-accordion-card-show': bet.isOpen}" 
            v-for="(bet) in myBets" 
            :key="bet.betSlipGroupId">
          <mybet-header :bet="bet" @loadDetails="loadDetails" />
          <div class="bto-sb-accordion-collapse" :class="{'bto-sb-accordion-show': bet.isOpen}">
            <div class="bto-sb-accordion-content bto-sb-mybets-content-loader" v-if="bet.isOpen && !bet.betDetails">
              <div class="bto-sb-spinner-v1"></div>
            </div>
            <mybet-details class="bto-sb-accordion-content" :betDetails="bet" v-if="bet.betDetails && !bet.noDetailsData" 
              @cashedOutBetToRemove="cashedOutBetToRemove" />
            <div v-else-if="bet.noDetailsData" class="bto-sb-accordion-content">
              <inline-message :message="t('A.MyBetsDetailsEmpty')" type="info"/>
            </div>
          </div>
        </div>
      </div>
      <empty-state v-else :message="t(infoMsg)" :iconClass="emptyStateIcon" />
      <div class="bto-sb-mybets-totals" v-if="myBets.length">
        <span>{{t('Mobile.totalStake')}}<i>{{myBetsTotals.stake|formatAmountDisplay}}</i></span>
        <span>{{t('W.TotWin')}}<i>{{myBetsTotals.winnings|formatAmountDisplay}}</i></span>
        <span v-if="myBetsTotals.potWinnings > 0">{{t('Mobile.PossibleWinnings')}}<i>{{myBetsTotals.potWinnings|formatAmountDisplay}}</i></span>
      </div>
      <div class="bto-sb-mybets-pagination" v-if="myBets.length">
        <span class="bto-sb-pagination-info">{{generatePaginationInfo}}</span>
        <pagination v-if="totalPages > 1" :maxVisibleButtons="3" :currentPage="currentPage" :totalPages="totalPages" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import Base from './base';
  import MybetsTabsService from '../../../../services/mybets/mybets-tabs-service';
  import AgentScrollerService from '../../../../agent/services/AgentScrollerService';
  import UserService from '../../../../services/user-service';
  import { BETSLIP_STATUS } from 'bto-models/betslip';
  import { MATCH_TYPES, DATE_FORMAT } from '../../../../models/enums/mybets-const';
  import MybetsModel from '../../../../models/mybets/model-mybets';
  import Pagination from '../../../../components/shared/pagination-component';
  import MybetHeader from '../mybet-header/web';
  import MybetDetails from '../mybet-details/web';

  export default {
    name: 'MybetsWeb',
    extends: Base,
    inheritAttrs: false,
    components: {
      MybetHeader,
      MybetDetails,
      Pagination,
    },
    data() {
      return {
        MATCH_TYPES,
        DATE_FORMAT,
        PLAYER_LANG: APP_SETTINGS.locale || APP_SETTINGS.player.language,
        TABS: MybetsTabsService.getOrderedTabs(),
        IS_AGENT: process.env.VUE_APP_IS_AGENT,
        toDate: null,
        fromDate: null,
        activeMatchType: null,
        betSlipSearch: null,
      };
    },
    props: {
      betSlipGroupId: {
        type: Number,
      },
    },
    computed: {
      myBetsTotals() {
        let totals = {
          winnings: 0,
          stake: 0,
          potWinnings: 0,
        };
        return this.myBets.reduce((prev, curr) => {
          prev.winnings += curr.winnings;
          prev.stake += curr.stake;
          if (this.checkStatus(curr, BETSLIP_STATUS.PLACED) || this.checkStatus(curr, BETSLIP_STATUS.PENDING)) {
            prev.potWinnings += curr.winnings;
          }
          return prev;
        }, totals);
      },
      totalPages() {
        if (this.myBets.length > 0) {
          return Math.ceil(+this.myBets[0].totalNumberOfItems / this.pageSize);
        }
        return 1;
      },
      generatePaginationInfo() {
        if (this.myBets.length > 0) {
          const tots = +this.myBets[0].totalNumberOfItems || 1;
          const start = ((this.currentPage - 1) * this.pageSize) + 1;
          let end = this.currentPage * this.pageSize;
          end = end < tots ? end : tots;
          return `${start}-${end} ${this.$translate.text('of')} ${tots} ${this.$translate.text('W.Items')}`;
        }
        return '';
      },
    },
    created() {
      const today = new Date();
      this.fromDate = new Date(today);
      this.fromDate.setDate(today.getDate() - 1);
      this.fromDate.setHours(0, 0, 0, 0);
      this.toDate = today;
      const dTab = (APP_SETTINGS.myBets.defaultTab || '').trim();
      this.activeTab = this.TABS.find(t => t.key === dTab) || this.TABS[0];

      if (APP_SETTINGS.myBets.resetDefaultDateFilters) {
        this.fromDate = null;
        this.toDate = null;
      }
      
      if (this.betSlipGroupId) {
        this.betSlipSearch = this.betSlipGroupId;
        this.getSingleDetail();
        return;
      }
      this.getHistory();
    },
    mounted() {
      if (this.IS_AGENT) {
        // Wait for page to render then set the height
        this.$once('hook:updated', () => {
          AgentScrollerService.setElHeight(this.$refs.mybetsMenu, 'mybetsMenu', 'mybets');
          AgentScrollerService.setElHeight(this.$refs.mybetsFilter, 'mybetsFilter', 'mybets');
        });
      }
    },
    methods: {
      cashedOutBetToRemove(betId) {
        const bet = this.myBets.find(mb => mb.betSlipGroupID === betId);
        if (bet) {
          (bet.combinations || []).forEach(comb => {
            comb.combinationStatusId = BETSLIP_STATUS.CACHEDOUT;
            comb.combStatus = this.$translate.text('BetSlipStatusType.CachedOut');
          });
          bet.betSlipGroupStatusId = BETSLIP_STATUS.CACHEDOUT;
          bet.betSlipGroupStatus = this.$translate.text('BetSlipStatusType.CachedOut');
        }
      },
      /**
       * Show only one open accordion at time
       */
      toggleAccordions(betId) {
        this.myBets = this.myBets.map(mb => ({
          ...mb,
          isOpen: mb.betSlipGroupID === betId ? !mb.isOpen : false,
        }));
      },
      loadDetails(bet) {
        this.toggleAccordions(bet.betSlipGroupID);
        this.getDetails(bet.betSlipGroupID);
      },
      onPageChange(page) {
        this.currentPage = page;
        this.getHistory();
      },
      /**
       * Search for mybets history or signle mybets detail
       */
      findMybets() {
        this.reset();
        if (this.betSlipSearch) {
          this.getSingleDetail();
          return;
        }
        this.getHistory();
      },
      getSingleDetail() {
        this.myBets = [{ betSlipGroupID: this.betSlipSearch, isOpen: true }];
        this.getDetails(this.betSlipSearch, true);
      },
      getHistory() {
        if (!UserService.userLoggedIn()) {
          this.infoMsg = 'Mobile.LoginFirst';
          return;
        }
        let request = this.getBaseMybetsRequestService();
        request.getParams.type = this.activeMatchType;
        const fromDate = this.fromDate && new Date(Date.UTC(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate(), 0, 0, 0, 0));
        const toDate = this.fromDate && new Date(Date.UTC(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate(), 23, 59, 59, 999));
        request.getParams.fromDate = fromDate;
        request.getParams.toDate = toDate;

        this.isLoading = true;
        request.execute((resp) => {
          this.resetLoading();
          if (!(resp.data && resp.data.length)) {
            this.myBets = [];
            return;
          }
          const mapedData = resp.data.map(mb => new MybetsModel(mb));
          this.myBets = mapedData;
        }, this.resetLoading);
      },
    },
  };
</script>
